<div class="sh-droppanel-wrapper">
    <div #toggleElement>
        <ng-content select="[droppanelToggle]"></ng-content>
    </div>
    <div
        #droppanel
        [class]="inOverflownContainer ? 'sh-droppanel--fixed' : 'sh-droppanel'"
        [ngClass]="[(calculatedOpenDirection$ | async) ?? '', droppanelStyle, clearMarginModifiers ? clearMarginModifiers : '']"
        [class.-sh-is-open]="isOpen$ | async"
    >
        <ng-content select="[header]"></ng-content>
        <div #droppanelList class="sh-droppanel__list" [ngStyle]="{ 'max-height': maxHeight$ | async, 'min-height': MIN_HEIGHT }">
            <ng-content></ng-content>
        </div>
        <ng-content select="[footer]"></ng-content>
    </div>
</div>
